import React from "react";
import { Typography, Box, Grid } from "@mui/material/";
import { HashLink } from "react-router-hash-link";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useTranslation } from "react-i18next";

const Menu = ({ current }) => {
  const { t, i18n } = useTranslation();
  console.log(
    "country code",
    JSON.parse(window.sessionStorage.getItem("iplookup")).countryCode
  );
  return (
    <Grid item md={2} sm={12} xs={12}>
      <Box sx={{ fontSize: "20px" }}>{t("CustomerService")}</Box>

      <Box sx={{ width: 1, border: "1px solid lightgray", mt: 5 }}>
        {JSON.parse(window.sessionStorage.getItem("iplookup")).countryCode ===
        "KR" ? (
          <>
            <HashLink smooth to="/message-board#top">
              <Box
                sx={{
                  p: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  "&:hover": { backgroundColor: "#f5f5f5" },
                  backgroundColor: current === "message" ? "#f5f5f5" : "white",
                  color: current === "message" ? "#153a5a" : "",
                  fontWeight: current === "message" ? 800 : 0,
                }}
              >
                <Box>{t("Board")}</Box>
                <ChevronRightIcon sx={{ fontSize: "17px" }} />
              </Box>
            </HashLink>
            <HashLink smooth to="/contact#top">
              <Box
                sx={{
                  borderTop: "1px solid lightgray",
                  width: 1,
                  "&:hover": { backgroundColor: "#f5f5f5" },
                }}
              >
                <Box
                  sx={{
                    p: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    "&:hover": { backgroundColor: "#f5f5f5" },
                    backgroundColor:
                      current === "contact" ? "#f5f5f5" : "white",
                    color: current === "contact" ? "#153a5a" : "",
                    fontWeight: current === "contact" ? 800 : 0,
                  }}
                >
                  <Box>{t("ContactUsLink")}</Box>
                  <ChevronRightIcon sx={{ fontSize: "17px" }} />
                </Box>
              </Box>{" "}
            </HashLink>
          </>
        ) : (
          <>
            <HashLink smooth to="/contact#top">
              <Box
                sx={{
                  // borderTop: "1px solid lightgray",
                  width: 1,
                  "&:hover": { backgroundColor: "#f5f5f5" },
                }}
              >
                <Box
                  sx={{
                    p: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    "&:hover": { backgroundColor: "#f5f5f5" },
                    backgroundColor:
                      current === "contact" ? "#f5f5f5" : "white",
                    color: current === "contact" ? "#153a5a" : "",
                    fontWeight: current === "contact" ? 800 : 0,
                  }}
                >
                  <Box>{t("ContactUsLink")}</Box>
                  <ChevronRightIcon sx={{ fontSize: "17px" }} />
                </Box>
              </Box>{" "}
            </HashLink>
          </>
        )}

        <HashLink smooth to="/b2b#top">
          <Box
            sx={{
              borderTop: "1px solid lightgray",
              width: 1,
              "&:hover": { backgroundColor: "#f5f5f5" },
            }}
          >
            <Box
              sx={{
                p: 2,
                display: "flex",
                justifyContent: "space-between",
                "&:hover": { backgroundColor: "#f5f5f5" },
                backgroundColor: current === "b2b" ? "#f5f5f5" : "white",
                color: current === "b2b" ? "#153a5a" : "",
                fontWeight: current === "b2b" ? 800 : 0,
              }}
            >
              <Box>{t("b2bRequest")}</Box>
              <ChevronRightIcon sx={{ fontSize: "17px" }} />
            </Box>
          </Box>
        </HashLink>
      </Box>
    </Grid>
  );
};

export default Menu;
